module.exports = __webpack_public_path__ + "static/media/exames_03.ed9950c1.jpg";